import * as vp from 'vopay';
import { useEffect, FC, useState } from 'react';
import useFetchVisaDirectPushTransaction from '@/hooks/useApi/useFetchVisaDirectPushTransaction';
import VisaDirectPushTransactionInfo from './VisaDirectPushTransactionInfo';

type VisaDirectPushTransactionContainerProps = {
  TransactionID: string;
  isParent?: boolean;
  jwt: string;
};

const VisaDirectPushTransactionContainer: FC<VisaDirectPushTransactionContainerProps> = ({
  TransactionID,
  isParent = false,
  jwt,
}) => {
  const [visaDirectPushTransaction, getVisaDirectPushTransaction] = useFetchVisaDirectPushTransaction({ bearer: jwt });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.VisaDirectPushTransactionResponse>();

  useEffect(() => {
    getVisaDirectPushTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (visaDirectPushTransaction) {
      setTransaction(visaDirectPushTransaction);
    }
  }, [visaDirectPushTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>
      {transaction && <VisaDirectPushTransactionInfo transaction={transaction} isParent={isParent} jwt={jwt} />}
    </div>
  );
};

export default VisaDirectPushTransactionContainer;
